<div *ngIf="isLoggedIn" class="p-4">
    <div class="container">
        <h1>Hi {{ user?.name }}!</h1>
        <p>You're logged in to Lead Carrot</p>
    </div>
</div>